<template>
  <div class="containerTable">
    <div
      style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;"
    >
      <div>
        <el-input
          v-model="listQuery.alert"
          placeholder="请输入公告标题"
          style="width: 200px; margin-right: 10px;"
          clearable
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          :loading="loading"
          @click="funcFilter"
        >
          查询
        </el-button>
      </div>
      <div>
        <el-button type="primary" icon="el-icon-plus" @click="funcAdd">
          新增
        </el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      border
      stripe
      :loading="loading"
      highlight-current-row
      @sort-change="sortList"
    >
      <el-table-column type="selection" width="60" />
      <el-table-column prop="alert" label="公告标题" min-width="150" />
      <el-table-column prop="content" label="公告内容" min-width="300">
        <template slot-scope="scope">
          <div class="content-html" v-html="scope.row.content" />
        </template>
      </el-table-column>
      <el-table-column prop="branchCode" label="所属机构" min-width="300">
        <template slot-scope="scope">
          {{ getBranchName(scope.row.branchCode) }}
        </template>
      </el-table-column>
      <el-table-column prop="gmtModified" label="修改时间" width="180" />
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="详情" placement="top">
            <el-button type="text" @click="funcDetail(scope.row.code)">
              <i class="el-icon-document" />
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page="listQuery.pageNum"
      :page-size="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="[10, 20, 30, 50]"
      layout="total, sizes, prev, pager, next, jumper"
      style="margin-top: 20px; text-align: right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <el-dialog
      :title="dialogTitle"
      :visible.sync="modelFlag"
      width="1200px"
      :modal-append-to-body="true"
      :append-to-body="true"
    >
      <compDetail
        v-if="modelFlag"
        ref="detailRef"
        :mode="currentMode"
        :code="currentCode"
        @success="handleSuccess"
        @cancel="modelFlag = false"
      />
    </el-dialog>

    <el-image-viewer
      v-if="showImageViewer"
      :on-close="closeImageViewer"
      :url-list="[previewImageUrl]"
    />
  </div>
</template>
<script>
import compDetail from "./components/announcementDetail.vue";
import { getAnnouncementList, deleteAnnouncement } from "@/api/user";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  name: "PlateformAnnouncement",
  components: {
    compDetail,
    ElImageViewer
  },
  data() {
    return {
      timer: "",
      currentCode: "",
      currentMode: "detail",
      loading: false,
      tableData: [],
      modelFlag: false,
      showImageViewer: false,
      previewImageUrl: "",
      listQuery: {
        alert: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  computed: {
    dialogTitle() {
      switch (this.currentMode) {
        case "add":
          return "新增平台公告";
        case "edit":
          return "修改平台公告";
        case "detail":
        default:
          return "平台公告详情";
      }
    },
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  created() {
    this.findList();
  },
  mounted() {
    this.$nextTick(() => {
      this.bindImageClick();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.bindImageClick();
    });
  },
  beforeDestroy() {
    this.unbindImageClick();
  },
  methods: {
    bindImageClick() {
      const container = this.$el;
      if (!container) return;
      container.addEventListener("click", this.handleImageClick, true);
    },
    unbindImageClick() {
      const container = this.$el;
      if (!container) return;
      container.removeEventListener("click", this.handleImageClick, true);
    },
    handleImageClick(e) {
      if (e.target.tagName === "IMG") {
        e.preventDefault();
        e.stopPropagation();
        this.previewImageUrl = e.target.src;
        this.showImageViewer = true;
      }
    },
    closeImageViewer() {
      this.showImageViewer = false;
      this.previewImageUrl = "";
    },
    getBranchName(code) {
      const item = this.branchList.find(item => item.code === code);
      return item ? item.groupName : "";
    },
    findList() {
      this.loading = true;
      getAnnouncementList(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        this.loading = false;
      });
    },
    funcAdd() {
      this.currentMode = "add";
      this.currentCode = "";
      this.modelFlag = true;
    },
    funcEdit(code) {
      this.currentMode = "edit";
      this.currentCode = code;
      this.modelFlag = true;
    },
    funcDetail(code) {
      this.currentMode = "detail";
      this.currentCode = code;
      this.modelFlag = true;
    },
    funcDelete(code) {
      this.$confirm("确认删除该公告吗？")
        .then(_ => {
          deleteAnnouncement({ codes: code }).then(response => {
            this.$message({
              message: response.msg || "删除成功",
              type: "success"
            });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    handleSuccess(type) {
      this.modelFlag = false;
      this.findList();
    },
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.findList();
    },
    sortList({ prop, order }) {
      this.listQuery.sortField = prop;
      this.listQuery.sortType = order === "ascending" ? "asc" : "desc";
      this.findList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.listQuery.pageNum = 1;
      this.findList();
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.findList();
    }
  }
};
</script>
<style scoped>
.containerTable {
  padding: 20px;
}
.content-html ::v-deep img {
  width: 50px;
  height: 50px;
  cursor: pointer;
}
</style>
